import React from 'react'
import KnowledgeMapControls from './KnowledgeMap/KnowledgeMapControls'
import NodeList from './KnowledgeMap/NodeList'
import NodeInfo from './KnowledgeMap/NodeInfo'
import { Row, Col } from 'reactstrap'
import nodeSourceOptions from '../../config/nodeSourceOptions'
const has = require('mout/object/has')

/*

Heirarchy of Nodes
List of Nodes

Active node allows management of details of nodes including children, parents, exemplars, items, descriptions, name, etc.

Components:
  List of Nodes

  ActiveNode Components:
    
    NodeInfo gives: 
      Id (can't change)
      Name (can change)
      Descriptions (can change)



    x Parents (List)
    x Children (List)
       

  x New Node button
  Delete button for node (have to also convert references to false??? gulp)

  x Add Parents
  x Add Children

  !!!!!! When you add a parent or a child, the child or parent needs to be added to the inverse in the db as a batch write !!!!!!!

  delete parent or child from relationship using delete button in each row

  Make it so you can navigate with the parents/children

  x Save button



*/

// props: rowsData, listName

export default function KnowledgeMap (props) {
  let activeNodeId = null
  if (has(props, 'activeNode.id')) {
    activeNodeId = props.activeNode.id
  }

  return (
    <Row>
      <Col xs='12' md='6'>
        <Row>
          <KnowledgeMapControls 
            xs='12' lg='12' 
            isChanged={props.isChanged} 
            saveChanges={props.saveChanges} 
            addNewNode={props.addNewNode}
            deleteNode={props.deleteNode}
            deleteDisabled={activeNodeId ? false : true}
          />
          <NodeList 
            xs='12' lg='12' 
            listName='All Nodes' 
            rowsData={props.searchedRows} 
            selector={true} 
            activeNodeId={activeNodeId}
            search={props.search}
            handleChange={props.handleChange}
          />
        </Row>
      </Col>
      <Col>
        <Row>
          <NodeList 
          xs='12' lg='12' 
            listName='Parents' 
            rowsData={props.parentNodes} 
            nodes={props.nodes} 
            nodesAvail={props.nonParentNodes}
            selectedNodeToAddId={props.addParentVal}
            handleChange={props.handleChange}
            saveParentChild={props.saveParentChild}
            selectedNodeId={props.addParentVal}
            removeParentChild={props.removeParentChild}
          />
          <NodeInfo 
            xs='12' lg='12' 
            activeNode={props.activeNode} 
            handleChange={props.handleChange}
            activeNodeName={props.activeNodeName}
            nodeLongDescription={props.nodeLongDescription}
            nodeShortDescription={props.nodeShortDescription}
            nodeCode={props.nodeCode}
            nodeSource={props.nodeSource}
            nodeSourceOptions={nodeSourceOptions}
            nameRef={props.nameRef}
          />
          <NodeList 
            xs='12' lg='12' 
            listName='Children' 
            rowsData={props.childrenNodes} 
            nodes={props.nodes}
            nodesAvail={props.nonChildrenNodes} 
            selectedNodeToAddId={props.addChildVal}
            handleChange={props.handleChange}
            saveParentChild={props.saveParentChild}
            selectedNodeId={props.addChildVal}
            removeParentChild={props.removeParentChild}
          />
        </Row>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/KnowledgeMap.js